import { Routes } from '@angular/router';
import { MAT_DIALOG_DEFAULT_OPTIONS } from '@angular/material/dialog';
import { MessageBoxService } from '@fundamental-ngx/core';
import { PipelineReleaseViewResolver } from './pipeline-release-view/pipeline-release-view.resolver';

export const routes: Routes = [
  {
    path: 'dashboard',
    loadComponent: () =>
      import('./pipeline-dashboard-view/pipeline-dashboard-view.component').then((c) => c.PipelineDashboardViewComponent),
    providers: [
      { provide: MAT_DIALOG_DEFAULT_OPTIONS, useValue: { enterAnimationDuration: 0, exitAnimationDuration: 0 } },
      MessageBoxService,
    ],
  },
  {
    path: 'release-view/delivery/:deliveryGuid/pipeline/:pipelineId',
    loadComponent: () => import('./pipeline-release-view/pipeline-release-view.component').then((c) => c.PipelineReleaseViewComponent),
    resolve: {
      data: PipelineReleaseViewResolver,
    },
  },
  {
    path: '**',
    redirectTo: 'dashboard',
  },
];
